import { get, post } from "../../../../../common/api";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  POLICY_ADD,
  EMPLOYEE_NAMES_WITH_CITY,
  CLAIM_ADD,
  CLAIM_EDIT,
  ENDORSEMENT_EDIT,
  ENDORSEMENT_ADD,
  QUOTE_ADD,
  QUOTE_EDIT,
  SHARE_DOC_ON_MAIL,
  API_GET_INSURER_LIST
} from "../../../../../common/constant";
import Api from "../../../../../common/api/multipart";


export const actionPolicyAdd = createAsyncThunk(
  "formStore/actionPolicyAdd",
  async (params, thunkAPI) => {
    try {
      return await Api.multipart(
        `${POLICY_ADD}/${params.dynamic_url}`,
        params, thunkAPI);
    } catch (error) {
      return thunkAPI.rejectWithValue(parseErrorv1(error) || error.message);
    }
  }
);

export const actionEmployeeNamesWithCity = createAsyncThunk(
  "formStore/actionEmployeeNamesWithCity",
  async (params, thunkAPI) => {
    return await get(`${EMPLOYEE_NAMES_WITH_CITY}`, params, thunkAPI);
  }
);

export const actionClaimAdd = createAsyncThunk(
  "formStore/actionClaimAdd",
  async (params, thunkAPI) => {
    try {
      return await Api.multipart(`${CLAIM_ADD}/${params.dynamic_url}`, params, thunkAPI);
    } catch (error) {
      return thunkAPI.rejectWithValue(parseErrorv1(error) || error.message);
    }
  }
);

export const actionClaimEdit = createAsyncThunk(
  "formStore/actionClaimEdit",
  async (params, thunkAPI) => {
    try {
      return await Api.multipart(CLAIM_EDIT, params, thunkAPI);
    } catch (error) {
      return thunkAPI.rejectWithValue(parseErrorv1(error) || error.message);
    }
  }
);

export const actionEndorsementAdd = createAsyncThunk(
  "formStore/actionEndorsementAdd",
  async (params, thunkAPI) => {
    try {
      return await Api.multipart(ENDORSEMENT_ADD, params, thunkAPI);
    } catch (error) {
      return thunkAPI.rejectWithValue(parseErrorv1(error) || error.message);
    }
  }
);

export const actionEndorsementEdit = createAsyncThunk(
  "formStore/actionEndorsementEdit",
  async (params, thunkAPI) => {
    try {
      return await Api.multipart(ENDORSEMENT_EDIT, params, thunkAPI);
    } catch (error) {
      return thunkAPI.rejectWithValue(parseErrorv1(error) || error.message);
    }
  }
);

// Quote Add 
export const actionQuoteAdd = createAsyncThunk(
  "formStore/actionQuoteAdd",
  async (params, thunkAPI) => {
    try {
      return await Api.multipart(
        QUOTE_ADD,
        params, thunkAPI);
    } catch (error) {
      return thunkAPI.rejectWithValue(parseErrorv1(error) || error.message);
    }
  }
);

// Quote Edit
export const actionQuoteEdit = createAsyncThunk(
  "formStore/actionQuoteEdit",
  async (params, thunkAPI) => {
    try {
      return await Api.multipart(QUOTE_EDIT, params, thunkAPI)
    } catch (error) {
      return thunkAPI.rejectWithValue(parseErrorv1(error) || error.message);
    }
  }
);

export const actionShareDocOnMail = createAsyncThunk(
  "formStore/actionShareDocOnMail",
  async (params, thunkAPI) => {
    try {
      return await post(SHARE_DOC_ON_MAIL, params, thunkAPI)
    } catch (error) {
      return thunkAPI.rejectWithValue(parseErrorv1(error) || error.message);
    }
  }
)


export const actionGetInsurerList = createAsyncThunk("formStore/actionGetInsurerList",
  async (params, thunkAPI) => {
    try {
      return await get(API_GET_INSURER_LIST, params, thunkAPI)
    } catch (error) {
      return thunkAPI.rejectWithValue(parseErrorv1(error) || error.message);
    }
  }
)


export const formSlice = createSlice({
  name: "formStore",

  initialState: {
    loadingForm: false,

    // policyAdd
    PolicyAdd: null,

    // policyEdit
    EmployeeNamesWithCity: null,

    // claimAdd
    ClaimAdd: null,

    // claimEdit
    ClaimEdit: null,

    // EndorsementAdd
    EndorsementAdd: null,

    // EndorsementEdit
    EndorsementEdit: null,

    // Quote Add
    QuoteAdd: null,

    // Quote Edit
    QuoteEdit: null,

    loadingShareDocOnEmail: false,
    ShareDocOnMail: null,

    getInsurerList: null

  },

  reducers: {
    resetPolicyAdd: (state) => {
      state.PolicyAdd = null;
    },

    resetEmployeeNamesWithCity: (state) => {
      state.EmployeeNamesWithCity = null;
    },

    resetClaimAdd: (state) => {
      state.ClaimAdd = null;
    },

    resetClaimEdit: (state) => {
      state.ClaimEdit = null;
    },

    resetEndorsementAdd: (state) => {
      state.EndorsementAdd = null;
    },

    resetEndorsementEdit: (state) => {
      state.EndorsementEdit = null;
    },

    // Quote add 
    resetQuoteAdd: (state) => {
      state.QuoteAdd = null;
    },
    // Quote Edit
    resetQuoteEdit: (state) => {
      state.QuoteEdit = null;
    },
    // Share Doc ON mail
    resetShareDocOnEmail: (state) => {
      state.ShareDocOnMail = null;
    },

    resetGetInsurerList: (state) => {
      state.getInsurerList = null
    }
  },

  extraReducers: (builder) => {
    builder
      .addCase(actionPolicyAdd.pending, (state) => {
        state.loadingForm = true;
      })
      .addCase(actionPolicyAdd.fulfilled, (state, action) => {
        state.loadingForm = false;
        state.PolicyAdd = action.payload;
      })
      .addCase(actionPolicyAdd.rejected, (state, action) => {
        state.loadingForm = false;
        state.PolicyAdd = { status: false, message: action.payload };
      })

      .addCase(actionEmployeeNamesWithCity.pending, (state) => {
        state.loadingForm = true;
      })
      .addCase(actionEmployeeNamesWithCity.fulfilled, (state, action) => {
        state.loadingForm = false;
        state.EmployeeNamesWithCity = action.payload;
      })
      .addCase(actionEmployeeNamesWithCity.rejected, (state) => {
        state.loadingForm = false;
      })

      .addCase(actionClaimAdd.pending, (state) => {
        state.loadingForm = true;
      })
      .addCase(actionClaimAdd.fulfilled, (state, action) => {
        state.loadingForm = false;
        state.ClaimAdd = action.payload;
      })
      .addCase(actionClaimAdd.rejected, (state, action) => {
        state.loadingForm = false;
        state.ClaimAdd = { status: false, message: action.payload };
      })

      .addCase(actionClaimEdit.pending, (state) => {
        state.loadingForm = true;
      })
      .addCase(actionClaimEdit.fulfilled, (state, action) => {
        state.loadingForm = false;
        state.ClaimEdit = action.payload;
      })
      .addCase(actionClaimEdit.rejected, (state, action) => {
        state.loadingForm = false;
        state.ClaimEdit = { status: false, message: action.payload };
      })

      .addCase(actionEndorsementAdd.pending, (state) => {
        state.loadingForm = true;
      })
      .addCase(actionEndorsementAdd.fulfilled, (state, action) => {
        state.loadingForm = false;
        state.EndorsementAdd = action.payload;
      })
      .addCase(actionEndorsementAdd.rejected, (state, action) => {
        state.loadingForm = false;
        state.EndorsementAdd = { status: false, message: action.payload };
      })

      .addCase(actionEndorsementEdit.pending, (state) => {
        state.loadingForm = true;
      })
      .addCase(actionEndorsementEdit.fulfilled, (state, action) => {
        state.loadingForm = false;
        state.EndorsementEdit = action.payload;
      })
      .addCase(actionEndorsementEdit.rejected, (state, action) => {
        state.loadingForm = false;
        state.EndorsementEdit = { status: false, message: action.payload };
      })

      // Quote Add
      .addCase(actionQuoteAdd.pending, (state) => {
        state.loadingForm = true;
      })
      .addCase(actionQuoteAdd.fulfilled, (state, action) => {
        state.loadingForm = false;
        state.QuoteAdd = action.payload;
      })
      .addCase(actionQuoteAdd.rejected, (state, action) => {
        state.loadingForm = false;
        state.QuoteAdd = { status: false, message: action.payload };
      })

      // Quote Edit 
      .addCase(actionQuoteEdit.pending, (state) => {
        state.loadingForm = true;
      })
      .addCase(actionQuoteEdit.fulfilled, (state, action) => {
        state.loadingForm = false;
        state.QuoteEdit = action.payload;
      })
      .addCase(actionQuoteEdit.rejected, (state, action) => {
        state.loadingForm = false;
        state.QuoteEdit = { status: false, message: action.payload };
      })

      // Share doc on mail
      .addCase(actionShareDocOnMail.pending, (state) => {
        state.loadingShareDocOnEmail = true;
      })
      .addCase(actionShareDocOnMail.fulfilled, (state, action) => {
        state.loadingShareDocOnEmail = false;
        state.ShareDocOnMail = action.payload;
      })
      .addCase(actionShareDocOnMail.rejected, (state, action) => {
        state.loadingShareDocOnEmail = false;
        state.ShareDocOnMail = { status: false, message: action.payload };
      })


      .addCase(actionGetInsurerList.fulfilled, (state, action) => {
        state.getInsurerList = action.payload;
      })
  },
});

export const {
  resetPolicyAdd,
  resetEmployeeNamesWithCity,
  resetClaimAdd,
  resetClaimEdit,
  resetEndorsementAdd,
  resetEndorsementEdit,
  resetQuoteAdd,
  resetQuoteEdit,
  resetShareDocOnEmail,
  resetGetInsurerList
} = formSlice.actions;

function parseErrorv1(error) {
  return error?.response?.data?.message;
}
export default formSlice.reducer;
